

import {useEffect, useState} from "react";

// react-router-dom components
import { useLocation, NavLink } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";

// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";

// Material Dashboard 2 React context
// import {
//
//   setTransparentSidenav,
//   setWhiteSidenav,
// } from "context";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {Logout, setCurrentRoutes, setMiniSidenav, setTransparentSidenav, setWhiteSidenav} from "../../actions";
import LocalStorage from "../../utils/LocalStorage";
import routes from "../../routes";
import adminRoutes from "../../adminRoutes";
import {convertRoutes, extractKeys, filterRoutes, findRoutes, keyToNodeMap} from "../../utils/globalFunction";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {collapseIconBox, collapseItem, collapseText} from "./styles/sidenavCollapse";
import ListItem from "@mui/material/ListItem";
import linearGradient from "../../assets/theme/functions/linearGradient";

function Sidenav({ color, brand, brandName,fixed,alertHeight,setLoading,...rest }) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const collapseName = location.pathname.split("/")[location.pathname.split("/").length -1];
  const dispatch = useDispatch()
  const miniSidenav = useSelector(state => state?.common?.miniSidenav)
  const transparentNavbar = useSelector(state => state?.common?.transparentNavbar)
  const openConfigurator = useSelector(state => state?.common?.openConfigurator)
  const darkMode = useSelector(state => state?.common?.darkMode)
  const transparentSidenav = useSelector(state => state?.common?.transparentSidenav)
  const whiteSidenav =  useSelector(state => state?.common?.whiteSidenav)
  const sidenavColor =  useSelector(state => state?.common?.sidenavColor)
  const loading = useSelector(state => state?.auth.loading)
  const [hideNav,setHideNav] = useState(false)
  const menuList = useSelector(state => state?.auth.menuList)
  const currentRoutes = useSelector(state => state?.auth?.currentRoutes)
  const [isFixed, setIsFixed] = useState(false);
  const [link,setLink] = useState('/app/dashboard')


  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => dispatch(setMiniSidenav(dispatch, true));

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      dispatch(setMiniSidenav(window.innerWidth < 1300));
      dispatch(setTransparentSidenav( window.innerWidth < 1300 ? false : transparentSidenav));
      dispatch(setWhiteSidenav(window.innerWidth < 1300 ? false : whiteSidenav));
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);

  }, [dispatch, location]);

    useEffect(() => {
        const keys = JSON.parse(LocalStorage.getItem('keys'))
        if(keys && keys.length > 0){
            const result = findRoutes(keys, keyToNodeMap)
            setLink(`/app${result}`)
        }
    }, [dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsFixed(scrollPosition >= 0); // 当滚动位置到达顶部时固定
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(()=>{

    if(!loading && LocalStorage.getItem('keys')){
      dispatch(setCurrentRoutes(filterRoutes([...adminRoutes], JSON.parse(LocalStorage.getItem('keys')))))

    }

    if(LocalStorage.getItem('user_roles') && loading){
      setHideNav(false)
    }

    if(!loading && LocalStorage.getItem('user_roles') && menuList.length>0){
      setHideNav(false)

    }

    if(loading && !LocalStorage.getItem('user_roles')){
      setHideNav(true)
    }

  },[loading])

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const renderRoutes = currentRoutes.filter(route=> route.isAuth ).map(({ type, name, icon, title, noCollapse, key, href, route, children}) => {
    let returnValue;
    if (type === "collapse" && !children) {
      returnValue = href ? (
          <Link
              href={`/app${href}`}
              key={key}
              target="_blank"
              rel="noreferrer"
              sx={{ textDecoration: "none" }}
          >
            <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
            />
          </Link>
      ) : (
          <NavLink key={key} to={`/app${route}`}>
            <SidenavCollapse name={name} icon={icon} active={key === collapseName} setTabLoading={setLoading} rootRoute={route}/>
          </NavLink>
      );
    }
    else if(type === "collapse" && children) {

      returnValue = href ? (

          <SidenavCollapse
              name={name}
              icon={icon}
              active={key === collapseName}
              noCollapse={noCollapse}
              setTabLoading={setLoading}
              key={key}
          />

      ) : (

          <SidenavCollapse name={name} key={key} icon={icon} active={key === collapseName} child={children} rootRoute={route} setTabLoading={setLoading}/>

      );

    } else if (type === "title") {
      returnValue = (
          <MDTypography
              sx={miniSidenav?{display:'none'}:{display: 'block'}}
              key={key}
              color={textColor}
              display="block"
              variant="caption"
              fontWeight="bold"
              textTransform="uppercase"
              pl={3}
              mt={2}
              mb={1}
              ml={1}
          >
            {title}
          </MDTypography>
      );
    } else if (type === "divider") {
      returnValue = (
          <Divider
              key={key}
              light={
                  (!darkMode && !whiteSidenav && !transparentSidenav) ||
                  (darkMode && !transparentSidenav && whiteSidenav)
              }
          />
      );
    }

    return returnValue;
  });

  return (
      <SidenavRoot
          {...rest}
          variant="permanent"
          ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
          alertHeight={alertHeight}
          fixed={fixed}
          sx={{
              zIndex: 1200, // Drawer 的层级，确保高于其他内容
              display: "flex",
              flexDirection: "column", // 垂直布局
              height: "100vh", // 占满视口高度
              overflow: "hidden", // 防止滚动内容溢出
              backgroundColor: whiteSidenav ? "#fff" : "inherit", // 设置背景色，防止内容透光
          }}
      >
        <MDBox pt={3} pb={1} px={4} textAlign="center" sx={{ zIndex: 2 }}>
          <MDBox
              display={{ xs: "block", xl: "none" }}
              position="absolute"
              top={0}
              right={0}
              p={1.625}
              onClick={closeSidenav}
              sx={{ cursor: "pointer" }}
          >
            <MDTypography variant="h6" color="secondary">
              <Icon sx={{ fontWeight: "bold" }}>close</Icon>
            </MDTypography>
          </MDBox>
          <MDBox component={NavLink} to={link} display="flex" alignItems="center" flexDirection={'column'} sx={{textAlign:'center',justifyContent:'center'}}>
            {brand && <MDBox sx={miniSidenav?{display:'none'}:{display: 'block'}} component="img" src={brand} alt="Brand" width="90%" />}
            <MDBox
                width={!brandName && "100%"}
                sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
                style={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'10px'}}
            >
              <MDTypography  align="center" component="h5" variant="button" fontWeight="medium" color={textColor}>
                {brandName}✨
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
        <Divider
            light={
                (!darkMode && !whiteSidenav && !transparentSidenav) ||
                (darkMode && !transparentSidenav && whiteSidenav)
            }
        />
        <List>
            <MDBox sx={{ flex: 1, overflowY: "auto" ,zIndex: 1, overflowX:'hidden',// 滚动区域层级较低
                position: "relative",}}>{!hideNav && renderRoutes}</MDBox>
        </List>
        {/*<MDBox p={2} mt="auto">*/}
        {/*  <MDButton*/}
        {/*      sx={miniSidenav?{display:'none'}:{display: 'block'}}*/}
        {/*      onClick={()=>dispatch(Logout())}*/}
        {/*      target="_blank"*/}
        {/*      rel="noreferrer"*/}
        {/*      variant="gradient"*/}
        {/*      color={sidenavColor}*/}
        {/*      fullWidth*/}
        {/*  >*/}
        {/*    Log Out*/}
        {/*  </MDButton>*/}
        {/*</MDBox>*/}
          <MDBox p={1} mt="auto"
                 sx={(theme) => {
                     const { palette } = theme;
                     const { transparent, white, gradients, background } = palette;

                     const backgroundValue = (() => {
                         if (transparentSidenav && darkMode) {
                             return background.sidenav; // 同时为 true 时背景为黑色
                         } else if (transparentSidenav && !darkMode) {
                             return white.main; // transparentSidenav 为 true，darkMode 为 false 时背景为白色
                         }  else if (whiteSidenav) {
                             return white.main;
                         } else {
                             return darkMode
                                 ? background.sidenav
                                 : linearGradient(gradients.dark.main, gradients.dark.state);
                         }
                     })();

                     return {
                         background: backgroundValue, // 动态设置背景
                         position: "sticky",
                         bottom: 0,
                         zIndex: 3,
                         boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.3)",
                     };
                 }}
          >
              {/*<Divider*/}
              {/*    light={*/}
              {/*        (!darkMode && !whiteSidenav && !transparentSidenav) ||*/}
              {/*        (darkMode && !transparentSidenav && whiteSidenav)*/}
              {/*    }*/}
              {/*/>*/}
              {
                  !JSON.parse(LocalStorage.getItem('keys')).some(k => k.trim() === 'ticket') &&
                  <MDBox display="flex" >
                      {/* 问号图标 */}
                      <ListItem component="li" sx={{display:'flex',flexDirection:'column'}} >
                          <MDBox
                              onClick={() => window.open('https://darwynnfulfillment.freshdesk.com', '_blank')}
                              {...rest}

                              sx={(theme) =>
                                  collapseItem(theme, {
                                      transparentSidenav,
                                      whiteSidenav,
                                      darkMode,
                                      sidenavColor,
                                  })
                              }

                          >
                              <ListItemIcon
                                  sx={(theme) =>
                                      collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode  })
                                  }
                              >
                                  <Icon>{'help_outline'}</Icon>
                              </ListItemIcon>

                              <ListItemText
                                  primary={t(`Sidebar.Ticket System`)}
                                  sx={(theme) =>
                                      collapseText(theme, {
                                          miniSidenav,
                                          transparentSidenav,
                                          whiteSidenav,
                                      })
                                  }
                              />
                          </MDBox>
                      </ListItem>
                  </MDBox>
              }

              <MDBox display="flex" >
                  {/* 问号图标 */}

                  <ListItem component="li" sx={{display:'flex',flexDirection:'column'}} >
                      <MDBox
                          onClick={() => window.open('https://darwynndispatch.freshdesk.com', '_blank')}
                          {...rest}

                          sx={(theme) =>
                              collapseItem(theme, {
                                  transparentSidenav,
                                  whiteSidenav,
                                  darkMode,
                                  sidenavColor,
                              })
                          }

                      >
                          <ListItemIcon
                              sx={(theme) =>
                                  collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode  })
                              }
                          >
                              <Icon>calendar_today</Icon>
                          </ListItemIcon>

                          <ListItemText
                              primary={t('Sidebar.Schedule')}
                              sx={(theme) =>
                                  collapseText(theme, {
                                      miniSidenav,
                                      transparentSidenav,
                                      whiteSidenav,
                                  })
                              }
                          />
                      </MDBox>
                  </ListItem>
              </MDBox>
              <MDBox>
                  <MDButton
                      sx={miniSidenav?{display:'none'}:{display: 'block'}}
                      onClick={()=>dispatch(Logout())}
                      target="_blank"
                      rel="noreferrer"
                      variant="gradient"
                      color={sidenavColor}
                      fullWidth
                  >
                      {t("Log Out")}
                  </MDButton>
              </MDBox>

          </MDBox>
      </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
};

export default Sidenav;
